var map = {
	"./Bash.svg": 651,
	"./C++.svg": 230,
	"./C.svg": 124,
	"./CSS.svg": 302,
	"./Figma.svg": 504,
	"./Git.svg": 287,
	"./Go.svg": 967,
	"./GraphQL.svg": 776,
	"./HTML.svg": 734,
	"./JavaScript.svg": 888,
	"./Linux.svg": 629,
	"./Next.svg": 986,
	"./Python.svg": 531,
	"./React.svg": 398,
	"./ReduxToolkit.svg": 685,
	"./TypeScript.svg": 440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;